export default __webpack_public_path__ + "static/media/dumbleApplause.48da580b.webp";